export const calcKeys = [
  'insurancePremium',
  'insuranceMonthlyPayment',
  'countyTaxMonthlyPayment',
  'totalEscrowPayment',
  'insuranceAmountCollected',
  'insuranceMonthCollected',
  'taxAmountCollected',
  'taxMonthCollected',
  'insuranceAgentName',
  'insuranceAgentAddress',
  'insuranceCompanyName',
  'nfipCommunityDate',
  'floodProgram',
  'communityPanelNo',
  'floodZoneDetermination',
  'determinationDate',
  'determinationReportNo',
  'appraisalDate',
  'parcelNo',
  'asIsAppraisedValue',
  'asRepairedAppraisedValue',
  'asIsValue',
  'afterRepairValue',
]
